import { useNationality } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useNationality";
import { useRetailerFinancial } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailerFinancial";
import { useSignUpRequest } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useQuery as useIncomeRangeQuery } from "@faire/web-api--source/endpoints/www/api/user/income-ranges/get-hooks";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { useMemo } from "react";

import ReportedCreationTime = IRetailer.ReportedCreationTime;

const UPMARKET_ANNUAL_SALES = 100000000;

export const useRetailerUpmarket = () => {
  const [{ country }] = useSignUpRequest(["country"]);
  const { retailerCountry } = useNationality();
  const { currency: displayCurrency } = useRetailerFinancial();
  const { data: incomeRangesData } = useIncomeRangeQuery({
    country: country ?? retailerCountry,
  });
  const upmarketConfigurationValues = incomeRangesData?.upmarket_configuration;

  const upmarketMinAnnualSalesCents =
    upmarketConfigurationValues?.minimum_annual_sales_eligible_for_upmarket
      ?.amount_cents ?? UPMARKET_ANNUAL_SALES;

  const isElegibleForUpmarket = (
    annualSalesMinAmount?: IFaireMoney,
    creationTime?: keyof typeof ReportedCreationTime
  ) =>
    (annualSalesMinAmount?.amount_cents ?? 0) >= upmarketMinAnnualSalesCents &&
    !isOwFEligible(creationTime);

  const potentialNetTermsAmount = useMemo(
    () =>
      upmarketConfigurationValues?.maximum_potential_net_terms_if_upmarket ??
      IFaireMoney.build({ amount_cents: 10000000, currency: displayCurrency }),
    [
      displayCurrency,
      upmarketConfigurationValues?.maximum_potential_net_terms_if_upmarket,
    ]
  );
  return { isElegibleForUpmarket, potentialNetTermsAmount };
};

const isOwFEligible = (
  creationTime?: keyof typeof ReportedCreationTime
): boolean => {
  return ["OPENING_SOON", "STARTED_THIS_YEAR", "STARTED_ONE_YEAR_AGO"].includes(
    creationTime ?? ""
  );
};
